import { render, staticRenderFns } from "./HazardClassCreateOrUpdate.vue?vue&type=template&id=15f55ff6&"
import script from "./HazardClassCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./HazardClassCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports